import React from 'react';
import katapultBoostLogo from '../../assets/img/katapult-boost.png';
import katapultProtectionLogo from '../../assets/img/katapult-protection.png';

export const FAQdata = [
  {
    title: 'How do I pay less by buying early?',
    content: (
      <>
        <p>You do not have to continue making scheduled payments through the full lease term.</p>
        <p>
          You can purchase the merchandise early at any time while your lease is active and become the owner sooner.
          Purchasing within the first 3 months generally provides the greatest savings.
        </p>
        <p>
          There is no early purchase penalty. Your current early purchase amount will be shown in your Katapult account.
        </p>
        <p>
          If you choose to continue making all scheduled payments through the full lease term, you become the owner
          automatically.
        </p>
      </>
    ),
  },
  {
    title: 'What is the amount due today?',
    content: (
      <>
        <p>The amount due today is your initial payment to start the lease.</p>
        <p>
          Your regular scheduled lease payments begin afterward according to the payment amount and frequency shown in
          your offer.
        </p>
      </>
    ),
  },
  {
    title: 'What is Katapult Protection+?',
    content: (
      <div className="k-faq-rich-card">
        <img src={katapultProtectionLogo} alt="Katapult Protection +" className="k-faq-rich-card__logo" />
        <p className="k-faq-rich-card__tagline">Protect your purchase</p>
        <p>
          This optional program covers your leased item(s) if <strong>stolen</strong> or{' '}
          <strong>damaged beyond repair</strong> by natural disaster, so you won&apos;t pay out of pocket or lose
          progress toward ownership.
        </p>
        <ul className="k-faq-rich-card__list">
          <li>
            <strong>Theft &amp; Natural Disaster Coverage</strong>
            <br />
            Covers the cost if your leased item is stolen or damaged in a covered event like fire, flood, windstorm,
            etc.
          </li>
          <li>
            <strong>Merchandise replacement</strong>
            <br />
            If your item(s) is destroyed, get it replaced, without restarting your lease or losing progress toward
            ownership.
          </li>
        </ul>
        <p className="k-faq-rich-card__footer">This option plan is confirmed at checkout</p>
      </div>
    ),
  },
  {
    title: 'What is Katapult Boost?',
    content: (
      <div className="k-faq-rich-card">
        <img src={katapultBoostLogo} alt="Katapult Boost" className="k-faq-rich-card__logo" />
        <p className="k-faq-rich-card__tagline">Personal and Lifestyle benefits</p>
        <ul className="k-faq-rich-card__list k-faq-rich-card__list--dash">
          <li>Involuntary Unemployment Payment Waiver*&#8224;</li>
          <li>Accident &amp; Sickness Payment Waiver*&#8224;</li>
          <li>Road Hazard*&#8224;</li>
          <li>Discount Health &amp; Wellness benefits*</li>
          <li>Dining and Food Discounts</li>
          <li>Savings on Local and Online Shopping</li>
          <li>Discounts on Professional Services</li>
        </ul>
        <p className="k-faq-rich-card__footer">Plus more you won&apos;t want to miss!</p>
        <div className="k-faq-rich-card__disclaimer">
          <p>
            *These benefits are NOT insurance or a substitute for insurance. Subject to limitations, restrictions and
            exclusions. Benefits vary by state. Not all members are eligible for all benefits.
          </p>
          <p>&#8224;Must be a member in good standing at the time of event.</p>
        </div>
      </div>
    ),
  },
];
